import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

import { Preloader } from '@/src/ui/';
import { useAuth } from '@/src/app/context/useAuth';

const LogoutPage: React.FC = () => {
    document.title = 'Logout';

    const { logout } = useAuth();
    const [shouldRedirect, setShouldRedirect] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                logout(true);
            } catch (error) {
                console.error('Error during logout:', error);
            } finally {
                setTimeout(() => setShouldRedirect(true), 1500);
            }
        })();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (shouldRedirect) {
        return <Navigate to="/login" replace />;
    }

    return <Preloader message="Signing you out..." />;
};

export default LogoutPage;
